/**
 * @file ShowTelReserveModal
 */
'use strict'

/**
 * @classname ShowTelReserveModal
 * @classdesc 電話予約のモーダルを表示する
 */
export default class ShowTelReserveModal {
	/**
	 * @constructor
	 * @param {jQuery} $e - .btn--reserve-tel
	 */
	constructor($e) {
		console.log('ShowTelReserveModal.constructor')
		this._$e = $e
		this._$modal = $e.closest('.modal')
		this._$target = $('#modal--mtg-appointment')
		$e.on('click', () => this.onClick())
	}

	/**
	 * クリックのコールバック
	 *
	 * @memberof ShowTelReserveModal
	 * @return {undefined}
	 */
	onClick() {
		console.log('ShowTelReserveModal.onClick')
		this._$modal.hide('hide');
		this._$target.fadeToggle('swing')
	}

}
